export const formatSecondsToHMS = (value: any) => {
  const totalSeconds = Number(value);
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) return "-";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const pad = (num: number) => String(num).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export const table = {
  primaryData: [
    { title: "ID", value: "id", type: "configue" },
    {
        title:"Entity Name",
        value:"entityName",
        type:"configue"
    },
    {
        title:"Entity Type",
        value:"entityType",
        type:"configue"
    },
    {
        title:"Entity Value",
        value:"entityValue",
        type:"configue"
    },
    {
        title: "Project Name",
        value:"projectName",
        type:"configue"
    },
    {
        title:"Joined At",
        value:"joinedAt",
        type:"configue"
    },
    {
        title:"Left At",
        value:"leftAt",
        type:"configue"
    },
    {
        title:"Time Spent (hh:mm:ss)",
        value:"timeSpentInSeconds",
        type:"configue"
    },
    {
        title:"Has Attended",
        value:"hasAttended",
        type:"configue"
    },
    {
        title:"Is Active",
        value:"isActive",
        type:"configue"
    },

  ],
  secondaryData: [

    {
        title:"Created At",
        value:"createdAt",
        type:"configue"
    },
    {
        title:"Updated At",
        value:"updatedAt",
        type:"configue",
        name:"updatedAt"
    },
    {
        title:"Created By",
        value:"createdByName",
        type:"configue"
    },
    {
        title:"Updated By",
        value:"updatedByName",
        type:"configue",
        name:"updatedByName"
    },
  ],
};


